import React from 'react';
import ComponentCreator from '@docusaurus/ComponentCreator';

export default [
  {
    path: '/en/search',
    component: ComponentCreator('/en/search', '62b'),
    exact: true
  },
  {
    path: '/en/docs',
    component: ComponentCreator('/en/docs', 'db1'),
    routes: [
      {
        path: '/en/docs',
        component: ComponentCreator('/en/docs', 'aec'),
        routes: [
          {
            path: '/en/docs',
            component: ComponentCreator('/en/docs', 'ecd'),
            routes: [
              {
                path: '/en/docs/api-reference/overview',
                component: ComponentCreator('/en/docs/api-reference/overview', 'f10'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/add-customer-address',
                component: ComponentCreator('/en/docs/api-reference/public/add-customer-address', 'ad2'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/advance-sandbox-subscription-billing',
                component: ComponentCreator('/en/docs/api-reference/public/advance-sandbox-subscription-billing', '0cf'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/apply-checkout-session-coupon',
                component: ComponentCreator('/en/docs/api-reference/public/apply-checkout-session-coupon', '64a'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/archive-plan',
                component: ComponentCreator('/en/docs/api-reference/public/archive-plan', '3ac'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/archive-product',
                component: ComponentCreator('/en/docs/api-reference/public/archive-product', '005'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/cancel-charge',
                component: ComponentCreator('/en/docs/api-reference/public/cancel-charge', 'ba7'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/cancel-subscription',
                component: ComponentCreator('/en/docs/api-reference/public/cancel-subscription', '789'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/change-subscription-plan',
                component: ComponentCreator('/en/docs/api-reference/public/change-subscription-plan', '39d'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/create-charge',
                component: ComponentCreator('/en/docs/api-reference/public/create-charge', 'a4f'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/create-checkout-session',
                component: ComponentCreator('/en/docs/api-reference/public/create-checkout-session', '876'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/create-coupon',
                component: ComponentCreator('/en/docs/api-reference/public/create-coupon', '3ce'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/create-customer',
                component: ComponentCreator('/en/docs/api-reference/public/create-customer', 'b72'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/create-plan',
                component: ComponentCreator('/en/docs/api-reference/public/create-plan', '642'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/create-product',
                component: ComponentCreator('/en/docs/api-reference/public/create-product', 'e1e'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/create-product-digital-file-upload-url',
                component: ComponentCreator('/en/docs/api-reference/public/create-product-digital-file-upload-url', '9da'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/create-product-image-upload-url',
                component: ComponentCreator('/en/docs/api-reference/public/create-product-image-upload-url', '85b'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/create-subscription',
                component: ComponentCreator('/en/docs/api-reference/public/create-subscription', '1a0'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/decide-sandbox-merchant-kyb',
                component: ComponentCreator('/en/docs/api-reference/public/decide-sandbox-merchant-kyb', 'b14'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/delete-customer-card',
                component: ComponentCreator('/en/docs/api-reference/public/delete-customer-card', '825'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/deliver-merchant-event',
                component: ComponentCreator('/en/docs/api-reference/public/deliver-merchant-event', '3c8'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/disable-coupon',
                component: ComponentCreator('/en/docs/api-reference/public/disable-coupon', 'bc6'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/get-checkout-session-public-view',
                component: ComponentCreator('/en/docs/api-reference/public/get-checkout-session-public-view', '724'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/get-checkout-session-status',
                component: ComponentCreator('/en/docs/api-reference/public/get-checkout-session-status', '766'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/get-coupon',
                component: ComponentCreator('/en/docs/api-reference/public/get-coupon', '78b'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/get-customer',
                component: ComponentCreator('/en/docs/api-reference/public/get-customer', '37f'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/get-plan',
                component: ComponentCreator('/en/docs/api-reference/public/get-plan', '6ff'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/get-product',
                component: ComponentCreator('/en/docs/api-reference/public/get-product', '119'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/get-refund',
                component: ComponentCreator('/en/docs/api-reference/public/get-refund', '5ac'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/get-subscription',
                component: ComponentCreator('/en/docs/api-reference/public/get-subscription', '099'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/list-charge-refunds',
                component: ComponentCreator('/en/docs/api-reference/public/list-charge-refunds', 'dbb'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/list-charges',
                component: ComponentCreator('/en/docs/api-reference/public/list-charges', '22b'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/list-coupons',
                component: ComponentCreator('/en/docs/api-reference/public/list-coupons', '6d0'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/list-customer-cards',
                component: ComponentCreator('/en/docs/api-reference/public/list-customer-cards', '519'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/list-customers',
                component: ComponentCreator('/en/docs/api-reference/public/list-customers', '6b3'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/list-plans',
                component: ComponentCreator('/en/docs/api-reference/public/list-plans', 'db1'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/list-products',
                component: ComponentCreator('/en/docs/api-reference/public/list-products', '9da'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/list-subscriptions',
                component: ComponentCreator('/en/docs/api-reference/public/list-subscriptions', '71d'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/mupag-public-merchant-api',
                component: ComponentCreator('/en/docs/api-reference/public/mupag-public-merchant-api', '090'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/patch-subscription',
                component: ComponentCreator('/en/docs/api-reference/public/patch-subscription', '845'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/pause-subscription',
                component: ComponentCreator('/en/docs/api-reference/public/pause-subscription', '5d6'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/pay-checkout-session',
                component: ComponentCreator('/en/docs/api-reference/public/pay-checkout-session', '5c9'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/reactivate-subscription',
                component: ComponentCreator('/en/docs/api-reference/public/reactivate-subscription', '4b5'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/remove-checkout-session-coupon',
                component: ComponentCreator('/en/docs/api-reference/public/remove-checkout-session-coupon', '3cd'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/renew-checkout-session',
                component: ComponentCreator('/en/docs/api-reference/public/renew-checkout-session', '0ee'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/request-refund',
                component: ComponentCreator('/en/docs/api-reference/public/request-refund', '45d'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/resume-subscription',
                component: ComponentCreator('/en/docs/api-reference/public/resume-subscription', 'dc7'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/seed-sandbox-data',
                component: ComponentCreator('/en/docs/api-reference/public/seed-sandbox-data', '479'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/select-checkout-session-method',
                component: ComponentCreator('/en/docs/api-reference/public/select-checkout-session-method', '677'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/simulate-sandbox-charge-failed',
                component: ComponentCreator('/en/docs/api-reference/public/simulate-sandbox-charge-failed', '5bf'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/simulate-sandbox-charge-paid',
                component: ComponentCreator('/en/docs/api-reference/public/simulate-sandbox-charge-paid', '1f0'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/simulate-sandbox-psp-subaccount-decision',
                component: ComponentCreator('/en/docs/api-reference/public/simulate-sandbox-psp-subaccount-decision', '21a'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/update-coupon',
                component: ComponentCreator('/en/docs/api-reference/public/update-coupon', '1c0'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/update-customer',
                component: ComponentCreator('/en/docs/api-reference/public/update-customer', 'f6b'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/update-customer-address',
                component: ComponentCreator('/en/docs/api-reference/public/update-customer-address', 'ace'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/update-plan',
                component: ComponentCreator('/en/docs/api-reference/public/update-plan', '541'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/update-product',
                component: ComponentCreator('/en/docs/api-reference/public/update-product', '512'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/update-subscription-card',
                component: ComponentCreator('/en/docs/api-reference/public/update-subscription-card', 'd81'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/api-reference/public/validate-coupon',
                component: ComponentCreator('/en/docs/api-reference/public/validate-coupon', '408'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/changelog',
                component: ComponentCreator('/en/docs/changelog', '350'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/customers',
                component: ComponentCreator('/en/docs/customers', '3be'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/customers/coupons',
                component: ComponentCreator('/en/docs/customers/coupons', '019'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/customers/plans',
                component: ComponentCreator('/en/docs/customers/plans', '02d'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/customers/products',
                component: ComponentCreator('/en/docs/customers/products', 'd6e'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/finance/affiliates-and-payouts',
                component: ComponentCreator('/en/docs/finance/affiliates-and-payouts', 'd38'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/fundamentals/errors',
                component: ComponentCreator('/en/docs/fundamentals/errors', '955'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/fundamentals/idempotency',
                component: ComponentCreator('/en/docs/fundamentals/idempotency', '244'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/fundamentals/pagination',
                component: ComponentCreator('/en/docs/fundamentals/pagination', 'ea6'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/fundamentals/rate-limits',
                component: ComponentCreator('/en/docs/fundamentals/rate-limits', 'dd9'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/fundamentals/versioning',
                component: ComponentCreator('/en/docs/fundamentals/versioning', '417'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/operations/status-support-feedback',
                component: ComponentCreator('/en/docs/operations/status-support-feedback', '152'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/payments/cards',
                component: ComponentCreator('/en/docs/payments/cards', '24c'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/payments/charges',
                component: ComponentCreator('/en/docs/payments/charges', 'db0'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/payments/checkout',
                component: ComponentCreator('/en/docs/payments/checkout', '5db'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/payments/pix',
                component: ComponentCreator('/en/docs/payments/pix', '930'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/start/authentication',
                component: ComponentCreator('/en/docs/start/authentication', 'eb2'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/start/environments',
                component: ComponentCreator('/en/docs/start/environments', 'b05'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/start/overview',
                component: ComponentCreator('/en/docs/start/overview', 'a7d'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/start/quickstart',
                component: ComponentCreator('/en/docs/start/quickstart', '117'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/subscriptions/overview',
                component: ComponentCreator('/en/docs/subscriptions/overview', '995'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/tools/ai-integration',
                component: ComponentCreator('/en/docs/tools/ai-integration', 'eeb'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/tools/sdk-and-tools',
                component: ComponentCreator('/en/docs/tools/sdk-and-tools', '059'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/webhooks/event-catalog',
                component: ComponentCreator('/en/docs/webhooks/event-catalog', 'afa'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/webhooks/overview',
                component: ComponentCreator('/en/docs/webhooks/overview', 'c51'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/webhooks/replay-safety',
                component: ComponentCreator('/en/docs/webhooks/replay-safety', '91b'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/webhooks/retries',
                component: ComponentCreator('/en/docs/webhooks/retries', '5ec'),
                exact: true,
                sidebar: "docsSidebar"
              },
              {
                path: '/en/docs/webhooks/signature',
                component: ComponentCreator('/en/docs/webhooks/signature', '7e0'),
                exact: true,
                sidebar: "docsSidebar"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '/en/',
    component: ComponentCreator('/en/', '6c2'),
    exact: true
  },
  {
    path: '*',
    component: ComponentCreator('*'),
  },
];
